export default {};

export const SETTINGS_TEXT = {
  pushMaterials: 'Sync materials created or updated in Ontraccr to QuickBooks, including changes made from a material debit workflow step',
  pullMaterials: 'Sync materials created or updated in QuickBooks to Ontraccr',
  pullInvoices: 'Sync Bills or Expenses created in QuickBooks to Ontraccr',
  ignoreInvoiceNoProject: 'Ignore syncing Bills or Expenses from QuickBooks that have no project',
  ignoreInvoiceNoProjectMatch: 'Ignore syncing Bills or Expenses from QuickBooks that have a project that doens\'t exist in Ontraccr',
};
